export const space = {
  'pt-none': '0rem',
  'pt-xs': '0.25rem',
  'pt-sm': '0.5rem',
  'pt-md': '1rem',
  'pt-lg': '1.5rem',
  'pt-xl': '2rem',
  'pt-xxl': '3rem',
};
